const ROOM_INFO_PUBLIC_ATTRS = []

const ROOM_INFO_LABEL = {}

const ROOM_TYPE = {
  'youshitusingle': '洋室シングル',
  'youshitusemidouble': '洋室セミダブル',
  'youshitudouble': '洋室ダブル',
  'youshitutwin': '洋室ツイン',
  'youshitutriple': '洋室トリプル',
  'youshitufourth': '洋室フォース',
  'youshitufive-room': '洋室ファイブ以上',
  'washituwashitu': '和室',
  'wayouwayou': '和洋室',
  'otherother': 'その他'
}


export {
  ROOM_INFO_PUBLIC_ATTRS,
  ROOM_INFO_LABEL,
  ROOM_TYPE
}